import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface PlaceSignals {
  has_farm_shop: boolean;
  has_farm_sale_alcohol: boolean;
  has_accommodation: boolean;
}

/**
 * Batch-fetches place signals (farm shop / farm sale) for a list of place IDs.
 * Returns a Map<placeId, PlaceSignals>.
 * Skips call when placeIds is empty.
 */
export function usePlaceSignals(placeIds: string[]) {
  return useQuery({
    queryKey: ["place-signals", placeIds.slice().sort().join(",")],
    queryFn: async (): Promise<Map<string, PlaceSignals>> => {
      if (placeIds.length === 0) return new Map();

      const { data, error } = await supabase.rpc("get_place_signals", {
        p_place_ids: placeIds,
      });

      if (error) {
        console.error("get_place_signals error:", error);
        return new Map();
      }

      const map = new Map<string, PlaceSignals>();
      for (const row of data ?? []) {
      map.set(row.place_id, {
          has_farm_shop: row.has_farm_shop,
          has_farm_sale_alcohol: row.has_farm_sale_alcohol,
          has_accommodation: row.has_accommodation ?? false,
        });
      }
      return map;
    },
    enabled: placeIds.length > 0,
    staleTime: 5 * 60 * 1000,
  });
}
